import React, { useEffect, useState } from "react";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import axios from "axios";
import { DatePicker, Divider, Layout, Space, Typography } from "antd";
import StatByCharacter from "./StatByCharacter";
import StatByGame from "./StatByGame";
import AvgStatByGame from "./AvgStatByGame";

dayjs.extend(customParseFormat);
dayjs.locale('ko');

export default function EstherStat() {
  const [data, setData] = useState({
    statsByCharacter: [],
    statsByGame: []
  });
  const [targetDate, setTargetDate] = useState(dayjs());
  const [existDates, setExistDates] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    axios.get("/api/external/bser/exist-dates")
      .then(r => r.data)
      .then(data => setExistDates(data.map(date => dayjs(date))))
      .catch(error => console.error("Error fetching dates:", error));
  }, []);

  const disabledDate = current => {
    if (!current) {
      return false;
    }
    return !existDates.some(date => current.isSame(date, 'day'));
  };

  useEffect(() => {
    if (targetDate) {
      setLoading(true);
      axios.get("/api/external/bser/esther-stats", {
        params: {
          targetDate: targetDate.format("YYYY-MM-DD")
        }
      }).then(r => r.data)
        .then(data => setData(data))
        .finally(() => setLoading(false));
    }
  }, [targetDate]);

  const totalGameCount = data.statsByGame ? data.statsByGame.length : 0;

  return (
    <Layout style={{ background: '#ffffff' }}>
      <Layout.Content style={{ padding: '20px' }}>
        <Space direction="vertical" style={{ width: '100%' }} size="middle">
          <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            width: '100%',
            marginBottom: '20px'
          }}>
            <Space direction="horizontal" align="center">
              <DatePicker
                value={targetDate}
                onChange={setTargetDate}
                format="YYYY-MM-DD"
                disabledDate={disabledDate}
                allowClear={false}
                style={{ minWidth: '180px' }}
              />
            </Space>
            <div style={{ fontWeight: 'bold', whiteSpace: 'nowrap' }}>
              총 게임 수: {totalGameCount}
            </div>
          </div>

          <Typography.Title level={5} style={{ margin: 0 }}>
            플레이어 - 실험체 별 데이터
          </Typography.Title>
          <StatByCharacter
            data={data.statsByCharacter}
            loading={loading}
          />

          <Divider />

          <Typography.Title level={5} style={{ margin: 0 }}>
            게임별 평균 데이터
          </Typography.Title>
          <AvgStatByGame
            data={data.statsByGame}
            loading={loading}
          />

          <Divider />

          <Typography.Title level={5} style={{ margin: 0 }}>
            게임별 데이터
          </Typography.Title>
          <StatByGame
            data={data.statsByGame}
            loading={loading}
          />
        </Space>
      </Layout.Content>
    </Layout>
  );
}
